import { render, staticRenderFns } from "./utiles-detalles.vue?vue&type=template&id=d7ef11ba&scoped=true&"
import script from "./utiles-detalles.vue?vue&type=script&lang=ts&"
export * from "./utiles-detalles.vue?vue&type=script&lang=ts&"
import style0 from "./utiles-detalles.vue?vue&type=style&index=0&id=d7ef11ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ef11ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCol,VIcon,VRow,VSpacer})
